@if(!documentPicker){
<app-sticky-action-bar [noSave]="true">
</app-sticky-action-bar>
}
<div class="file-explorer-container" [class.height-full-minus-header-subheader]="!documentPicker">
  @if(!loading){

  <div class="view-mode-bar">
    <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
      <mat-label>Rechercher</mat-label>
      <input matInput [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()"
        placeholder="Nom de fichier ou dossier...">
      <mat-icon matPrefix>search</mat-icon>
      @if(searchQuery){
      <button matSuffix mat-icon-button (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
      }
    </mat-form-field>

    <mat-button-toggle-group [ngModel]="viewMode" (ngModelChange)="onViewModeChange($event)" class="view-toggle" hideSingleSelectionIndicator>
      <mat-button-toggle value="columns" matTooltip="Colonnes">
        <mat-icon>view_column</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="single" matTooltip="Colonne unique">
        <mat-icon>view_list</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="tree" matTooltip="Arborescence">
        <mat-icon>account_tree</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <!-- Templates réutilisables -->
  <ng-template #emptyMessage>
    <div class="empty-message">
      <mat-icon class="empty-icon">folder_open</mat-icon>
      <p>Aucun élément</p>
    </div>
  </ng-template>

  <ng-template #breadcrumbNav let-items="items" let-navigateFn="navigateFn">
    <nav class="breadcrumb">
      @for (crumb of items; track crumb.index; let last = $last) {
        @if(!last) {
          <span class="breadcrumb-item" (click)="navigateFn(crumb.index)">
            <mat-icon class="breadcrumb-icon folder">folder</mat-icon>
            {{ crumb.label }}
          </span>
          <mat-icon class="breadcrumb-separator">chevron_right</mat-icon>
        } @else {
          <span class="breadcrumb-item active">
            <mat-icon class="breadcrumb-icon folder">folder</mat-icon>
            {{ crumb.label }}
          </span>
        }
      }
      @if(previewColumn) {
        <mat-icon class="breadcrumb-separator">chevron_right</mat-icon>
        <span class="breadcrumb-item active">
          <mat-icon class="breadcrumb-icon file">{{ getFileIcon(previewColumn.file.type) }}</mat-icon>
          {{ previewColumn.file.name }}
        </span>
      }
    </nav>
  </ng-template>

  @if(searchResults) {
  <!-- Résultats de recherche globale -->
  <div class="search-results">
    @if(searchResults.folders.length === 0 && searchResults.files.length === 0) {
    <div class="empty-message">
      <mat-icon class="empty-icon">search_off</mat-icon>
      <p>Aucun résultat pour "{{ searchQuery }}"</p>
    </div>
    }

    @if(searchResults.folders.length > 0) {
    <div class="search-section-label">Dossiers</div>
    @for(folder of searchResults.folders; track folder.idRepertoire) {
    <div class="item" (click)="navigateToFolder(folder)">
      <mat-icon class="item-icon folder-icon">folder</mat-icon>
      <div class="search-result-info">
        <span class="item-name">{{ folder.nom }}</span>
        <span class="search-result-path">{{ getFolderPath(folder.idRepertoireParent) }}</span>
      </div>
      <mat-icon class="chevron-icon">chevron_right</mat-icon>
    </div>
    }
    }

    @if(searchResults.files.length > 0) {
    <div class="search-section-label">Fichiers</div>
    @for(file of searchResults.files; track file.id) {
    <div class="item" (click)="navigateToFile(file)">
      <mat-icon class="item-icon file-icon">{{ getFileIcon(file.type) }}</mat-icon>
      <div class="search-result-info">
        <span class="item-name">{{ file.name }}</span>
        <span class="search-result-path">{{ getFolderPath(file.idRepertoire) }}</span>
      </div>
    </div>
    }
    }
  </div>
  } @else {

  @if(viewMode === 'columns') {
  <!-- Fil d'Ariane -->
  <ng-container *ngTemplateOutlet="breadcrumbNav; context: { items: normalizedBreadcrumbs, navigateFn: navigateToBreadcrumb.bind(this) }"></ng-container>

  <div #container class="columns-container">
    <!-- Colonnes de navigation -->
    @for (column of columns; track $index; let columnIndex = $index) {
    <div class="column" [style.width.px]="columnWidths[columnIndex] || 280"
      [class.drop-target]="!selectMode && isDragOver === columnIndex"
      (dragover)="!selectMode && onDragOver($event, columnIndex)" (dragleave)="!selectMode && onDragLeave($event)"
      (drop)="!selectMode && onDrop($event, columnIndex)">
      <!-- Toolbar de la colonne -->
      <mat-toolbar class="column-toolbar">
        <button mat-icon-button [matMenuTriggerFor]="sortMenu" matTooltip="Trier">
          <mat-icon>sort</mat-icon>
        </button>
        <mat-menu #sortMenu="matMenu">
          <button mat-menu-item (click)="setSortColumn(columnIndex, 'name')">
            <mat-icon>{{ column.sortBy === 'name' ? 'check' : '' }}</mat-icon>
            <span>Nom {{ column.sortBy === 'name' ? (column.sortOrder === 'asc' ? '↑' : '↓') : '' }}</span>
          </button>
          <button mat-menu-item (click)="setSortColumn(columnIndex, 'date')">
            <mat-icon>{{ column.sortBy === 'date' ? 'check' : '' }}</mat-icon>
            <span>Date {{ column.sortBy === 'date' ? (column.sortOrder === 'asc' ? '↑' : '↓') : '' }}</span>
          </button>
          <button mat-menu-item (click)="setSortColumn(columnIndex, 'size')">
            <mat-icon>{{ column.sortBy === 'size' ? 'check' : '' }}</mat-icon>
            <span>Taille {{ column.sortBy === 'size' ? (column.sortOrder === 'asc' ? '↑' : '↓') : '' }}</span>
          </button>
          <button mat-menu-item (click)="setSortColumn(columnIndex, 'type')">
            <mat-icon>{{ column.sortBy === 'type' ? 'check' : '' }}</mat-icon>
            <span>Type {{ column.sortBy === 'type' ? (column.sortOrder === 'asc' ? '↑' : '↓') : '' }}</span>
          </button>
        </mat-menu>

        @if(multiSelectColumnIndex === columnIndex){
        <mat-checkbox
          [checked]="isAllSelectedInColumn(columnIndex)"
          [indeterminate]="isSomeSelectedInColumn(columnIndex)"
          (change)="toggleAllInColumn(columnIndex)"
          class="select-all-checkbox"
          matTooltip="Tout sélectionner">
        </mat-checkbox>
        }

        <span class="toolbar-spacer"></span>

        @if(multiSelectColumnIndex === columnIndex && fileSelection.selected.length > 0){
        <button mat-icon-button color="warn" (click)="deleteSelectedFiles()"
          matTooltip="Supprimer ({{ fileSelection.selected.length }})">
          <mat-icon>delete</mat-icon>
        </button>
        }

        @if(!readOnly){
        <button mat-icon-button (click)="toggleMultiSelect(columnIndex)"
          [matTooltip]="multiSelectColumnIndex === columnIndex ? 'Annuler la sélection' : 'Sélection multiple'"
          [color]="multiSelectColumnIndex === columnIndex ? 'primary' : ''">
          <mat-icon>{{ multiSelectColumnIndex === columnIndex ? 'close' : 'checklist' }}</mat-icon>
        </button>
        }

        @if(!readOnly || readOnly === 'add'){
        <button mat-icon-button [matMenuTriggerFor]="addMenu" matTooltip="Ajouter">
          <mat-icon>add</mat-icon>
        </button>
        <mat-menu #addMenu="matMenu">
          <button mat-menu-item (click)="createFolder(columnIndex)">
            <mat-icon color="primary">create_new_folder</mat-icon>
            <span>Nouveau dossier</span>
          </button>
          <button mat-menu-item (click)="addFile(columnIndex)">
            <mat-icon color="accent">upload_file</mat-icon>
            <span>Ajouter des fichiers</span>
          </button>
        </mat-menu>
        }
      </mat-toolbar>

      <div class="column-content">
        <!-- Message si vide -->
        @if(column.items.length === 0){
        <ng-container *ngTemplateOutlet="emptyMessage"></ng-container>
        }

        @for (item of column.items; track item.type === 'folder' ? item.folder.idRepertoire : item.file.id) {

        <!-- Dossier -->
        @if(item.type === 'folder'){
        <div class="item" [class.selected]="selectedFolderIds[columnIndex] === item.folder.idRepertoire"
          [class.dragging]="dragData?.type === 'folder' && dragData?.item === item.folder"
          [class.loading]="isFolderLoading(item.folder.idRepertoire)"
          [attr.draggable]="!selectMode && !isFolderLoading(item.folder.idRepertoire)"
          (dragstart)="!selectMode && !isFolderLoading(item.folder.idRepertoire) && onDragStart($event, 'folder', item.folder, columnIndex)"
          (dragend)="onDragEnd()"
          (click)="!isFolderLoading(item.folder.idRepertoire) && handleFolderClick(item.folder, columnIndex)"
          (contextmenu)="!isFolderLoading(item.folder.idRepertoire) && onContextMenu($event, 'folder', item.folder, columnIndex)">
          @if(isFolderLoading(item.folder.idRepertoire)){
          <mat-spinner diameter="20" class="item-spinner"></mat-spinner>
          }@else {
          <mat-icon class="item-icon folder-icon">folder</mat-icon>
          }
          <span class="item-name">{{ item.folder.nom }}</span>
          @if(!isFolderLoading(item.folder.idRepertoire)){
          @if(!readOnly){
          <button mat-icon-button class="item-menu-button" [matMenuTriggerFor]="folderMenu"
            (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #folderMenu="matMenu">
            <button mat-menu-item (click)="renameFolder(item.folder)">
              <mat-icon color="primary">edit</mat-icon>
              <span>Renommer</span>
            </button>
            <button mat-menu-item (click)="deleteFolder(item.folder)">
              <mat-icon color="warn">delete</mat-icon>
              <span>Supprimer</span>
            </button>
          </mat-menu>
          }
          <mat-icon class="chevron-icon">chevron_right</mat-icon>
          }
        </div>
        }

        <!-- Fichier -->
        @if(item.type === 'file'){
        <div class="item"
          [class.selected]="selectedFileId === item.file.id && selectedType === 'file' && selectedColumnIndex === columnIndex"
          [class.checked]="selectMode && isFileSelected(item.file)"
          [class.dragging]="dragData?.type === 'file' && dragData?.item === item.file"
          [class.loading]="isFileLoading(item.file.id)" [attr.draggable]="!selectMode && !isFileLoading(item.file.id)"
          (dragstart)="!selectMode && !isFileLoading(item.file.id) && onDragStart($event, 'file', item.file, columnIndex)"
          (dragend)="onDragEnd()" (click)="!isFileLoading(item.file.id) && handleFileClick(item.file, columnIndex)"
          (contextmenu)="!isFileLoading(item.file.id) && onContextMenu($event, 'file', item.file, columnIndex)">
          @if(selectMode){
          <mat-checkbox [checked]="isFileSelected(item.file)" (click)="toggleFileWithPreview($event, item.file, columnIndex)"
            class="file-checkbox"></mat-checkbox>
          }
          @if(multiSelectColumnIndex === columnIndex && !selectMode){
          <mat-checkbox [checked]="fileSelection.isSelected(item.file)" (click)="toggleFileMultiSelect($event, item.file)"
            class="file-checkbox"></mat-checkbox>
          }
          @if(isFileLoading(item.file.id)){
          <mat-spinner diameter="20" class="item-spinner"></mat-spinner>
          }@else {
          <mat-icon class="item-icon file-icon">{{ getFileIcon(item.file.type) }}</mat-icon>
          }
          <span class="item-name">{{ item.file.name }}</span>
          @if(!isFileLoading(item.file.id) && !readOnly){
          <button mat-icon-button class="item-menu-button" [matMenuTriggerFor]="fileMenu"
            (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #fileMenu="matMenu">
            <button mat-menu-item (click)="modifyFile(item.file)">
              <mat-icon color="primary">edit</mat-icon>
              <span>Modifier</span>
            </button>
            <button mat-menu-item (click)="deleteFile(item.file)">
              <mat-icon color="warn">delete</mat-icon>
              <span>Supprimer</span>
            </button>
          </mat-menu>
          }
        </div>
        }

        }

      </div>

      <!-- Resize handle -->
      @if(columnIndex < columns.length){ <div class="resize-handle"
        [class.resizing]="resizingColumnIndex === columnIndex" (mousedown)="startResize($event, columnIndex)">
    </div>
    }
  </div>
  }

  <!-- Colonne de preview qui prend tout l'espace restant -->
  @if(previewColumn){
  <div class="column preview-column">
    <app-file-preview-card
      [file]="previewColumn.file"
      [fileLoaded]="previewColumn.fileLoaded"
      [folderName]="getFolderName(previewColumn.file.idRepertoire)"
      (fileLoadedChange)="previewColumn.fileLoaded = $event"
      (openFileRequest)="openFile($event)">
    </app-file-preview-card>
  </div>
  }

</div>
  } @else if(viewMode === 'single') {
  <!-- Vue colonne unique -->
  <ng-container *ngTemplateOutlet="breadcrumbNav; context: { items: singleBreadcrumbs, navigateFn: navigateToSingleBreadcrumb.bind(this) }"></ng-container>

  <div class="single-container">
    @if(singleColumn) {
    <div class="single-panel">
      <!-- Toolbar -->
      <mat-toolbar class="column-toolbar">
        @if(singleColumnFolderHistory.length > 0) {
        <button mat-icon-button (click)="singleColumnGoBack()" matTooltip="Dossier parent">
          <mat-icon>arrow_back</mat-icon>
        </button>
        }

        <button mat-icon-button [matMenuTriggerFor]="singleSortMenu" matTooltip="Trier">
          <mat-icon>sort</mat-icon>
        </button>
        <mat-menu #singleSortMenu="matMenu">
          <button mat-menu-item (click)="setSortSingleColumn('name')">
            <mat-icon>{{ singleColumn.sortBy === 'name' ? 'check' : '' }}</mat-icon>
            <span>Nom {{ singleColumn.sortBy === 'name' ? (singleColumn.sortOrder === 'asc' ? '↑' : '↓') : '' }}</span>
          </button>
          <button mat-menu-item (click)="setSortSingleColumn('date')">
            <mat-icon>{{ singleColumn.sortBy === 'date' ? 'check' : '' }}</mat-icon>
            <span>Date {{ singleColumn.sortBy === 'date' ? (singleColumn.sortOrder === 'asc' ? '↑' : '↓') : '' }}</span>
          </button>
          <button mat-menu-item (click)="setSortSingleColumn('size')">
            <mat-icon>{{ singleColumn.sortBy === 'size' ? 'check' : '' }}</mat-icon>
            <span>Taille {{ singleColumn.sortBy === 'size' ? (singleColumn.sortOrder === 'asc' ? '↑' : '↓') : '' }}</span>
          </button>
          <button mat-menu-item (click)="setSortSingleColumn('type')">
            <mat-icon>{{ singleColumn.sortBy === 'type' ? 'check' : '' }}</mat-icon>
            <span>Type {{ singleColumn.sortBy === 'type' ? (singleColumn.sortOrder === 'asc' ? '↑' : '↓') : '' }}</span>
          </button>
        </mat-menu>

        @if(singleMultiSelect){
        <mat-checkbox
          [checked]="isAllSelectedInSingle()"
          [indeterminate]="isSomeSelectedInSingle()"
          (change)="toggleAllInSingle()"
          class="select-all-checkbox"
          matTooltip="Tout sélectionner">
        </mat-checkbox>
        }

        <span class="toolbar-spacer"></span>

        @if(singleMultiSelect && fileSelection.selected.length > 0){
        <button mat-icon-button color="warn" (click)="deleteSelectedFiles()"
          matTooltip="Supprimer ({{ fileSelection.selected.length }})">
          <mat-icon>delete</mat-icon>
        </button>
        }

        @if(!readOnly){
        <button mat-icon-button (click)="toggleSingleMultiSelect()"
          [matTooltip]="singleMultiSelect ? 'Annuler la sélection' : 'Sélection multiple'"
          [color]="singleMultiSelect ? 'primary' : ''">
          <mat-icon>{{ singleMultiSelect ? 'close' : 'checklist' }}</mat-icon>
        </button>
        }

        @if(!readOnly || readOnly === 'add'){
        <button mat-icon-button [matMenuTriggerFor]="singleAddMenu" matTooltip="Ajouter">
          <mat-icon>add</mat-icon>
        </button>
        <mat-menu #singleAddMenu="matMenu">
          <button mat-menu-item (click)="createFolderInSingle()">
            <mat-icon color="primary">create_new_folder</mat-icon>
            <span>Nouveau dossier</span>
          </button>
          <button mat-menu-item (click)="addFileInSingle()">
            <mat-icon color="accent">upload_file</mat-icon>
            <span>Ajouter des fichiers</span>
          </button>
        </mat-menu>
        }
      </mat-toolbar>

      <div class="column-content">
        @if(singleColumn.items.length === 0){
        <ng-container *ngTemplateOutlet="emptyMessage"></ng-container>
        }

        @for (item of singleColumn.items; track item.type === 'folder' ? item.folder.idRepertoire : item.file.id) {

        <!-- Dossier -->
        @if(item.type === 'folder'){
        <div class="item"
          [class.loading]="isFolderLoading(item.folder.idRepertoire)"
          (click)="!isFolderLoading(item.folder.idRepertoire) && handleSingleFolderClick(item.folder)">
          @if(isFolderLoading(item.folder.idRepertoire)){
          <mat-spinner diameter="20" class="item-spinner"></mat-spinner>
          }@else {
          <mat-icon class="item-icon folder-icon">folder</mat-icon>
          }
          <span class="item-name">{{ item.folder.nom }}</span>
          @if(!isFolderLoading(item.folder.idRepertoire)){
          @if(!readOnly){
          <button mat-icon-button class="item-menu-button" [matMenuTriggerFor]="singleFolderMenu"
            (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #singleFolderMenu="matMenu">
            <button mat-menu-item (click)="renameFolder(item.folder)">
              <mat-icon color="primary">edit</mat-icon>
              <span>Renommer</span>
            </button>
            <button mat-menu-item (click)="deleteFolder(item.folder)">
              <mat-icon color="warn">delete</mat-icon>
              <span>Supprimer</span>
            </button>
          </mat-menu>
          }
          <mat-icon class="chevron-icon">chevron_right</mat-icon>
          }
        </div>
        }

        <!-- Fichier -->
        @if(item.type === 'file'){
        <div class="item"
          [class.selected]="selectedFileId === item.file.id && selectedType === 'file'"
          [class.checked]="selectMode && isFileSelected(item.file)"
          [class.loading]="isFileLoading(item.file.id)"
          (click)="!isFileLoading(item.file.id) && handleSingleFileClick(item.file)">
          @if(selectMode){
          <mat-checkbox [checked]="isFileSelected(item.file)" (click)="toggleSingleFileWithPreview($event, item.file)"
            class="file-checkbox"></mat-checkbox>
          }
          @if(singleMultiSelect && !selectMode){
          <mat-checkbox [checked]="fileSelection.isSelected(item.file)" (click)="toggleFileMultiSelect($event, item.file)"
            class="file-checkbox"></mat-checkbox>
          }
          @if(isFileLoading(item.file.id)){
          <mat-spinner diameter="20" class="item-spinner"></mat-spinner>
          }@else {
          <mat-icon class="item-icon file-icon">{{ getFileIcon(item.file.type) }}</mat-icon>
          }
          <span class="item-name">{{ item.file.name }}</span>
          @if(!isFileLoading(item.file.id) && !readOnly){
          <button mat-icon-button class="item-menu-button" [matMenuTriggerFor]="singleFileMenu"
            (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #singleFileMenu="matMenu">
            <button mat-menu-item (click)="modifyFile(item.file)">
              <mat-icon color="primary">edit</mat-icon>
              <span>Modifier</span>
            </button>
            <button mat-menu-item (click)="deleteFile(item.file)">
              <mat-icon color="warn">delete</mat-icon>
              <span>Supprimer</span>
            </button>
          </mat-menu>
          }
        </div>
        }

        }
      </div>
    </div>
    }

    <!-- Preview dans le mode single -->
    @if(previewColumn){
    <div class="single-preview-panel">
      <app-file-preview-card
        [file]="previewColumn.file"
        [fileLoaded]="previewColumn.fileLoaded"
        [folderName]="getFolderName(previewColumn.file.idRepertoire)"
        (fileLoadedChange)="previewColumn.fileLoaded = $event"
        (openFileRequest)="openFile($event)">
      </app-file-preview-card>
    </div>
    }
  </div>

  } @else {
  <!-- Vue arborescence -->
  <div class="tree-container">
    <div class="tree-panel">
      <!-- Toolbar arborescence -->
      <mat-toolbar class="column-toolbar">
        <button mat-icon-button (click)="toggleExpandAllTree()"
          [matTooltip]="isAllTreeExpanded() ? 'Tout replier' : 'Tout déplier'">
          <mat-icon>{{ isAllTreeExpanded() ? 'unfold_less' : 'unfold_more' }}</mat-icon>
        </button>

        @if(treeMultiSelect){
        <mat-checkbox
          [checked]="isAllSelectedInTree()"
          [indeterminate]="isSomeSelectedInTree()"
          (change)="toggleAllInTree()"
          class="select-all-checkbox"
          matTooltip="Tout sélectionner">
        </mat-checkbox>
        }

        <span class="toolbar-spacer"></span>

        @if(treeMultiSelect && fileSelection.selected.length > 0){
        <button mat-icon-button color="warn" (click)="deleteSelectedFiles()"
          matTooltip="Supprimer ({{ fileSelection.selected.length }})">
          <mat-icon>delete</mat-icon>
        </button>
        }

        @if(!readOnly){
        <button mat-icon-button (click)="toggleTreeMultiSelect()"
          [matTooltip]="treeMultiSelect ? 'Annuler la sélection' : 'Sélection multiple'"
          [color]="treeMultiSelect ? 'primary' : ''">
          <mat-icon>{{ treeMultiSelect ? 'close' : 'checklist' }}</mat-icon>
        </button>
        }

        @if(!readOnly || readOnly === 'add'){
        <button mat-icon-button [matMenuTriggerFor]="treeAddMenu" matTooltip="Ajouter">
          <mat-icon>add</mat-icon>
        </button>
        <mat-menu #treeAddMenu="matMenu">
          <button mat-menu-item (click)="createFolderInTree()">
            <mat-icon color="primary">create_new_folder</mat-icon>
            <span>Nouveau dossier{{ treeSelectedFolderId ? ' dans "' + getFolderName(treeSelectedFolderId) + '"' : ' à la racine' }}</span>
          </button>
          <button mat-menu-item (click)="addFileInTree()">
            <mat-icon color="accent">upload_file</mat-icon>
            <span>Ajouter des fichiers{{ treeSelectedFolderId ? ' dans "' + getFolderName(treeSelectedFolderId) + '"' : ' à la racine' }}</span>
          </button>
        </mat-menu>
        }
      </mat-toolbar>

      <div class="tree-content">
        @if(treeData.length === 0) {
        <ng-container *ngTemplateOutlet="emptyMessage"></ng-container>
        } @else {
        <mat-tree #fileTree [dataSource]="treeData" [childrenAccessor]="treeChildrenAccessor" class="file-tree">
          <!-- Noeud feuille -->
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
            <button mat-icon-button disabled class="tree-toggle-placeholder"></button>
            @if(node.type === 'folder') {
            <div class="tree-node-content" [class.selected]="treeSelectedFolderId === node.folder.idRepertoire && selectedType === 'folder'"
              [class.loading]="isFolderLoading(node.folder.idRepertoire)"
              (click)="!isFolderLoading(node.folder.idRepertoire) && handleTreeFolderClick(node.folder, node)">
              @if(treeMultiSelect && !selectMode){
              <mat-checkbox [checked]="isAllSelectedInFolder(node.folder.idRepertoire)"
                [indeterminate]="isSomeSelectedInFolder(node.folder.idRepertoire)"
                (click)="toggleAllInFolder($event, node.folder.idRepertoire)"
                class="file-checkbox"
                matTooltip="Sélectionner tous les fichiers du dossier">
              </mat-checkbox>
              }
              @if(isFolderLoading(node.folder.idRepertoire)){
              <mat-spinner diameter="20" class="item-spinner"></mat-spinner>
              } @else {
              <mat-icon class="item-icon folder-icon">folder</mat-icon>
              }
              <span class="item-name">{{ node.name }}</span>
              @if(!isFolderLoading(node.folder.idRepertoire) && !readOnly){
              <button mat-icon-button class="item-menu-button" [matMenuTriggerFor]="treeFolderMenu"
                (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #treeFolderMenu="matMenu">
                <button mat-menu-item (click)="renameFolder(node.folder)">
                  <mat-icon color="primary">edit</mat-icon>
                  <span>Renommer</span>
                </button>
                <button mat-menu-item (click)="deleteFolder(node.folder)">
                  <mat-icon color="warn">delete</mat-icon>
                  <span>Supprimer</span>
                </button>
              </mat-menu>
              }
            </div>
            } @else {
            <div class="tree-node-content" [class.selected]="selectedFileId === node.file.id && selectedType === 'file'"
              [class.checked]="(selectMode && isFileSelected(node.file)) || (treeMultiSelect && fileSelection.isSelected(node.file))"
              [class.loading]="isFileLoading(node.file.id)"
              (click)="!isFileLoading(node.file.id) && handleTreeFileClick(node.file)">
              @if(selectMode){
              <mat-checkbox [checked]="isFileSelected(node.file)" (click)="toggleFileSelection($event, node.file)"
                class="file-checkbox"></mat-checkbox>
              }
              @if(treeMultiSelect && !selectMode){
              <mat-checkbox [checked]="fileSelection.isSelected(node.file)" (click)="toggleTreeFileMultiSelect($event, node.file)"
                class="file-checkbox"></mat-checkbox>
              }
              @if(isFileLoading(node.file.id)){
              <mat-spinner diameter="20" class="item-spinner"></mat-spinner>
              } @else {
              <mat-icon class="item-icon file-icon">{{ getFileIcon(node.file.type) }}</mat-icon>
              }
              <span class="item-name">{{ node.name }}</span>
              @if(!isFileLoading(node.file.id) && !readOnly){
              <button mat-icon-button class="item-menu-button" [matMenuTriggerFor]="treeFileMenu"
                (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #treeFileMenu="matMenu">
                <button mat-menu-item (click)="modifyFile(node.file)">
                  <mat-icon color="primary">edit</mat-icon>
                  <span>Modifier</span>
                </button>
                <button mat-menu-item (click)="deleteFile(node.file)">
                  <mat-icon color="warn">delete</mat-icon>
                  <span>Supprimer</span>
                </button>
              </mat-menu>
              }
            </div>
            }
          </mat-tree-node>

          <!-- Noeud expandable (dossier avec enfants) -->
          <mat-tree-node *matTreeNodeDef="let node; when: treeHasChild" matTreeNodePadding>
            <button mat-icon-button matTreeNodeToggle class="tree-toggle-btn"
              (click)="onTreeNodeToggle(node)">
              <mat-icon>{{ fileTree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </button>
            <div class="tree-node-content" [class.selected]="treeSelectedFolderId === node.folder.idRepertoire && selectedType === 'folder'"
              [class.loading]="isFolderLoading(node.folder.idRepertoire)"
              (click)="!isFolderLoading(node.folder.idRepertoire) && handleTreeFolderClick(node.folder, node)">
              @if(treeMultiSelect && !selectMode){
              <mat-checkbox [checked]="isAllSelectedInFolder(node.folder.idRepertoire)"
                [indeterminate]="isSomeSelectedInFolder(node.folder.idRepertoire)"
                (click)="toggleAllInFolder($event, node.folder.idRepertoire)"
                class="file-checkbox"
                matTooltip="Sélectionner tous les fichiers du dossier">
              </mat-checkbox>
              }
              @if(isFolderLoading(node.folder.idRepertoire)){
              <mat-spinner diameter="20" class="item-spinner"></mat-spinner>
              } @else {
              <mat-icon class="item-icon folder-icon">{{ fileTree.isExpanded(node) ? 'folder_open' : 'folder' }}</mat-icon>
              }
              <span class="item-name">{{ node.name }}</span>
              @if(!isFolderLoading(node.folder.idRepertoire) && !readOnly){
              <button mat-icon-button class="item-menu-button" [matMenuTriggerFor]="treeFolderMenuExp"
                (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #treeFolderMenuExp="matMenu">
                <button mat-menu-item (click)="renameFolder(node.folder)">
                  <mat-icon color="primary">edit</mat-icon>
                  <span>Renommer</span>
                </button>
                <button mat-menu-item (click)="deleteFolder(node.folder)">
                  <mat-icon color="warn">delete</mat-icon>
                  <span>Supprimer</span>
                </button>
              </mat-menu>
              }
            </div>
          </mat-tree-node>
        </mat-tree>
        }
      </div>
    </div>

    <!-- Preview dans le mode tree -->
    @if(previewColumn){
    <div class="tree-preview-panel">
      <app-file-preview-card
        [file]="previewColumn.file"
        [fileLoaded]="previewColumn.fileLoaded"
        [folderName]="getFolderName(previewColumn.file.idRepertoire)"
        (fileLoadedChange)="previewColumn.fileLoaded = $event"
        (openFileRequest)="openFile($event)">
      </app-file-preview-card>
    </div>
    }
  </div>
  }

}

}@else {
<app-loader></app-loader>
}
</div>

<!-- Dialog pour renommer/créer des dossiers -->
<ng-template #inputDialog>
  <app-dialog-header title="{{dialogTitle}}" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle />
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>{{ dialogLabel }}</mat-label>
      <input matInput [(ngModel)]="dialogValue" (keyup.enter)="confirmDialog()">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Annuler</button>
    <button mat-raised-button color="primary" (click)="confirmDialog()" [disabled]="!dialogValue?.trim()">
      {{ dialogConfirmText }}
    </button>
  </mat-dialog-actions>
</ng-template>
